// extracted by mini-css-extract-plugin
module.exports = {"animateGradientText":"SidebarItem_animateGradientText__2RQAF","animated-gradient":"SidebarItem_animated-gradient__3Z--e"};